var _circle, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMatched(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#29D6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1641 7.40018C10.1641 6.44305 8.91253 6.24016 8.41797 7.16512C8.39274 7.15218 8.40056 6.89851 8.40056 9.47994C8.60385 9.31217 8.84715 9.10276 9.08974 8.87359C10.0864 7.93124 10.1641 7.50747 10.1641 7.40018V7.40018Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83887 7.40021C5.83887 7.5075 5.91651 7.93127 6.91298 8.87362C7.15439 9.10185 7.39651 9.31009 7.59933 9.47738C7.59933 6.90169 7.60571 7.15461 7.58498 7.16515C7.08922 6.23793 5.83786 6.44583 5.83887 7.40021V7.40021Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.31765 6.51761H2V9.48231H3.31765V11.3647H7.6V10.3785C6.81555 9.78052 5.13409 8.38836 5.13365 7.40043C5.13285 6.06189 6.58558 5.45029 7.6 6.15431V4.63525H3.31765V6.51761ZM2.70588 8.77643V7.22349H3.31765V8.77643H2.70588Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0004 6.51761H12.6827V4.63525H8.40039V6.1562C9.42248 5.44424 10.8706 6.06909 10.8698 7.40043C10.8694 8.38841 9.18712 9.78125 8.40039 10.3809V11.3647H12.6827V9.48231H14.0004V6.51761ZM13.2945 8.77643H12.6827V7.22349H13.2945V8.77643Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatched);
export default __webpack_public_path__ + "static/media/matched.a1820c1e.svg";
export { ForwardRef as ReactComponent };